const DefaultColor = {
  // eMetroアプリのメインカラー
  main: "#1D2088",
  // 認証成功
  success: "#13A772",
  white: "#FFFFFF",
  // 区切り線
  separator: "#DFE3EF",
  // 空きあり
  open: "#00A0CD",
  // 空きなし
  close: "#FF4838",
  // 背景
  background: "#F1F0F8",
};

/**
 * 共通カラー情報
 */
export class Colors {
  /**
   * 共通カラー情報を取得
   */
  static get() {
    return DefaultColor;
  }
}
export default Colors;
